
import Layout from '../../components/layout'
import NaasCard from "../../components/naascard";
import SectionHeading from '../../components/SectionHeading'
import Slider from '../../components/slider'

import Stock1 from '../../assets/images/stock/stock-1.jpg'
import Stock2 from '../../assets/images/stock/stock-2.jpg'
import Stock5 from '../../assets/images/stock/stock-5.jpg'

import { useState } from 'react'

const services = [
  {
    title: "AceOps",
    description: "Grundtjänsten: vi tar hand om monitorering, dokumentation och drift av ert nätverk.",
    included: ["Monitorering, dokumentation och backuper", "Drift och rådgivning ingår", "Support för ärenden ni eskalerar", "Rabatterade timpriser"],
    selectRange: { from: 0, to: 25 },
    image: Stock1
  },
  {
    title: "AceNoc",
    description: "Vi kontaktar er när vi ser någonting som behöver åtgärdas.",
    included: ["Allt som ingår i AceOps", "Aktiv övervakning med eventhantering och felsökning", "Eskalering till ISP, TAC och era kontaktpersoner", "Livscykelhantering och RMA"],
    selectRange: { from: 26, to: 75 },
    image: Stock2
  },
  {
    title: "AceNaaS",
    description: "Vi tar fullt ansvar för ert nätverk.",
    included: ["Allt som ingår i AceOps och AceNoc", "Definierad SLA och tillgänglighet", "Fördefinierade ändringar och tickets", "Bygger på Acebit-validerad design"],
    selectRange: { from: 76, to: 100 },
    image: Stock5
  }
]

const inRange = (value, { from, to }) => value >= from && value <= to

export default function NaasPage() {
  const [responsibility, setResponsibility] = useState(20)

  const selectTier = (service) => {
    const { from, to } = service.selectRange
    setResponsibility(Math.round((from + to) / 2))
  }

  return (
    <Layout>
      <div id="naas" className="section flex flex-col gap-10 sm:gap-14">
        <SectionHeading
          eyebrow="Tjänster"
          title={<><span className="text-sky-500">Kompetens</span> som tjänst</>}
        >
          <p>Hur vill ni fördela ansvaret mellan er och er partner?</p>
          <p>Alla nivåer kan appliceras på er befintliga miljö, ger förutsägbara kostnader och har ingen bindningstid (3 månaders uppsägning).</p>
        </SectionHeading>

        <div className="flex flex-col gap-6 sm:gap-8">
          <div className="flex flex-col gap-2">
            <div className="grid grid-cols-3 gap-2 rounded-xl bg-slate-200/70 p-1 dark:bg-white/5">
              {services.map((service) => {
                const active = inRange(responsibility, service.selectRange)
                return (
                  <button
                    key={service.title}
                    type="button"
                    onClick={() => selectTier(service)}
                    className={`rounded-lg px-3 py-2 text-sm font-medium transition-colors duration-200 ${active
                      ? "bg-white text-slate-900 shadow-sm dark:bg-sky-500 dark:text-slate-950"
                      : "text-slate-500 hover:text-slate-900 dark:text-slate-400 dark:hover:text-white"
                      }`}
                  >
                    {service.title}
                  </button>
                )
              })}
            </div>

            <div className="px-2">
              <Slider
                onChange={(event) => setResponsibility(event.target.value)}
                value={responsibility}
              />
            </div>
            <div className="flex justify-between font-mono text-xs uppercase tracking-widest text-slate-500">
              <span>In house</span>
              <span>Partner</span>
            </div>
          </div>

          {/* Alla kort ligger i samma gridcell, så höjden är alltid det högsta kortets */}
          <div className="grid">
            {services.map((service) => (
              <NaasCard
                key={service.title}
                active={inRange(responsibility, service.selectRange)}
                title={service.title}
                description={service.description}
                included={service.included}
                image={service.image}
              />
            ))}
          </div>
        </div>
      </div>
    </Layout>
  )
}
